import theme from '../../../theme/news12'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css`
  .anchor-card {
    display: flex;
    flex-direction: column;
  }

  .thumbnail {
    aspect-ratio: 16 / 9;
    object-fit: cover;
  }

  .bio {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
  }

  .social {
    display: grid;
    column-gap: 20px;
    grid-template-columns: repeat(4, 24px);
  }

  .name {
    font-weight: 600;
    font-size: 16px;    
    margin-bottom: 0px;
  }

  .title {
    margin-top: 2px;
    font-weight: 400;
    font-size: 14px;
  }

  .social a {
    color: ${redesignedTheme.colors.mineShaft};
  }

  .social a.twitter:hover {
    color: ${theme.colors.social.twitter};
  }

  .social a.instagram:hover {
    color: ${theme.colors.social.instagram};
  }

  .social a.facebook:hover {
    color: ${theme.colors.social.facebook};
  }

  .social a.email:hover {
    color: ${theme.colors.royalBlue};
  }
`
